"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArrayCombinations = exports.intersectionArr = exports.symetricDiffArr = exports.findIndexAsync = exports.removeFromArrayAsync = exports.removeFromArray = void 0;
function removeFromArray(arr, checkFunc) {
    let index = arr.findIndex(t => checkFunc(t));
    while (index >= 0) {
        arr.splice(index, 1);
        index = arr.findIndex(t => checkFunc(t));
    }
}
exports.removeFromArray = removeFromArray;
function removeFromArrayAsync(arr, checkFunc) {
    return __awaiter(this, void 0, void 0, function* () {
        let index = yield findIndexAsync(arr, t => checkFunc(t));
        while (index >= 0) {
            arr.splice(index, 1);
            index = yield findIndexAsync(arr, t => checkFunc(t));
        }
    });
}
exports.removeFromArrayAsync = removeFromArrayAsync;
function findIndexAsync(arr, asyncCallback) {
    return __awaiter(this, void 0, void 0, function* () {
        const promises = arr.map(asyncCallback);
        const results = yield Promise.all(promises);
        const index = results.findIndex(result => result);
        return index;
    });
}
exports.findIndexAsync = findIndexAsync;
/**
 * @description you will get an array containing all the elements of arrA that are not in arrB and vice-versa, so the result should be [2,3,4,6,7].
 */
function symetricDiffArr(arrA, arrB) {
    return arrA.filter(x => !arrB.includes(x)).concat(arrB.filter(x => !arrA.includes(x)));
}
exports.symetricDiffArr = symetricDiffArr;
/**
 * @description Intersection of two arrays
 */
function intersectionArr(arrA, arrB) {
    return arrA.filter(x => arrB.includes(x));
}
exports.intersectionArr = intersectionArr;
function combinationUtil(arr, data, start, end, index, r, finalResult = []) {
    // Current combination is ready to be printed, print it
    if (index == r) {
        const t = [];
        for (let j = 0; j < r; j++) {
            t.push(data[j]);
        }
        finalResult.push(t);
    }
    for (let i = start; i <= end && end - i + 1 >= r - index; i++) {
        data[index] = arr[i];
        combinationUtil(arr, data, i + 1, end, index + 1, r, finalResult);
    }
    return finalResult;
}
// The main function that prints all combinations of size r
// in arr[] of size n. This function mainly uses combinationUtil()
function getArrayCombinations(arr, r) {
    let data = new Array(r);
    // Print all combination using temporary array 'data[]'
    return combinationUtil(arr, data, 0, arr.length - 1, 0, r);
}
exports.getArrayCombinations = getArrayCombinations;
